interface FormatParams {
    params: Array<string | number>;
    text: string;
}

export class Format {
    static params({ params, text }: FormatParams) {
        const parameters = text.match(/{(\d+)}/g);
        const hasParameters = parameters !== null;
        if (!hasParameters) return text;
        let textFormatted = text;
        parameters.forEach((parameter, index) => {
            textFormatted = textFormatted.replace(
                parameter,
                String(params[index])
            );
        });
        return textFormatted;
    }

    static onlyNumber(value: string) {
        value = value.replace(/\D/g, '');
        return value;
    }

    static onlyNumberAndLetter(value: string) {
        value = value.replace(/[^a-zA-Z0-9]/g, '');
        return value;
    }

    static maskPhone(value: string): string {
        value = value.replace(/\D/g, '');

        if (value.length <= 2) {
            return value;
        } else if (value.length <= 7) {
            return value.replace(/^(\d{2})(\d{0,5})/, '$1 $2');
        } else {
            return value.replace(/^(\d{2})(\d{5})(\d{0,4})$/, '$1 $2-$3');
        }
    }

    static formatCountryCode(value: string): string {
        value = value.replace(/[^\d]/g, '');

        value = value.replace('+', '');

        return `+${value}`;
    }

    static maskDate(value: string) {
        value = value.replace(/\D/g, '');
        value = value.replace(/^(\d{2})(\d)/, '$1/$2');
        value = value.replace(/(\d{2})(\d)/, '$1/$2');
        value = value.replace(/(\d)(\d{4})/, '$1/$2');
        return value;
    }

    static monthYear(value: string) {
        value = value.replace(/\D/g, '');
        let month = value.slice(0, 2);

        if (parseInt(month) > 12) {
            month = '12';
        }
        value = month + value.slice(2);
        value = value.replace(/^(\d{2})(\d)/, '$1/$2');

        value = value.length > 5 ? value.slice(0, 5) : value;

        return value;
    }

    static maskCPFCNPJ(value: string) {
        value = value.replace(/\D/g, '');
        if (value.length <= 11) {
            value = value.replace(/^(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d)/, '$1-$2');
            return value;
        } else {
            value = value.replace(/^(\d{2})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d)/, '$1/$2');
            value = value.replace(/(\d{4})(\d)/, '$1-$2');
            return value;
        }
    }

    static maskCPF(value: string) {
        value = value.replace(/\D/g, '');
        value = value.replace(/^(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1-$2');
        return value;
    }

    static maskCEP(value: string) {
        value = value.replace(/\D/g, ''); 
        value = value.replace(/^(\d{5})(\d)/, '$1-$2'); 
        value = value.substring(0, 9);
        return value;
    }

    static currency(value: number) {
        return new Intl.NumberFormat('pt-br', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 3,
        }).format(value);
    }

    static currencyWithoutFraction(value: number) {
        return new Intl.NumberFormat('pt-br', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 0,
            maximumFractionDigits: 3,
        }).format(value);
    }

    static convertCentsInReal(value: number) {
        return value / 100;
    }

    static getConvertCentsInRealFormatted(value: number) {
        return this.currency(this.convertCentsInReal(value));
    }

    static convertNumberCard(value: string) {
        value = value.replace(/\D/g, '');
        value = value.replace(' ', '');

        if (value.length > 16) return value;

        switch (value.length) {
            case 15:
                value = value.replace(/(\d{4})(\d{6})(\d{5})/g, '$1 $2 $3');
                break;
            default:
                value = value.replace(/(\d{4})(?=\d)/g, '$1 ');
                break;
        }

        return value;
    }
}
